import { CAlert, CContainer } from '@coreui/react';
import * as React from 'react';
import { Redirect } from 'react-router';
import { KLoadingPanel, NavMenu } from '../components';
import { AppLabels } from '../core/AppLabels';
import { securitySvc } from '../Karma';

// Propriétéq
interface IProps {
}

interface IState {
	loading: boolean;
	redirectUrl: string;
}

export class NotFoundView extends React.Component<IProps, IState> {

	public constructor(props: any) {
		super(props);

		this.state = {
			// Forcer loading à true si des chargements compémentaires sont effectués. 
			// Cela affichera une barre de progression
			loading: false,

			// Pour effectuer une redirection, saisir l'url ici. La redirection sera effactive au prochain rendu de la page
			redirectUrl: "",
		}
	}

	render() {
		// Ligne à supprimer si aucune authentification n'est requise
		if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>

		// 
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
		if (this.state.loading) return <KLoadingPanel></KLoadingPanel>

		return (
			<div>
				<NavMenu securityService={securitySvc} userFullName={securitySvc.currentUser.fullname} />
				<div className="Empty">

					<div className="KBreadcrum ">
						<span>{AppLabels.pageNotFoundTitle}</span>
					</div>

					<CContainer >
						<CAlert color="danger">
							<h4 className="alert-heading"> {AppLabels.pageNotFoundTitle}</h4>
							{AppLabels.pageNotFoundDetail}
						</CAlert>
					</CContainer>
				</div>
			</div>
		);
	}
}
